var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.topText)?_c('h5',{staticClass:"text-muted mb-2"},[_vm._v(" "+_vm._s(_vm.topText)+" ")]):_vm._e(),_c('h1',[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.subtitle !== '')?_c('p',{staticClass:"text-muted mb-4"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }